export const AUTH_TYPE_CHECK = 'LOGIN/AUTH_TYPE_CHECK';
export const AUTH_TYPE_CHECK_SUCCESS = 'LOGIN/AUTH_TYPE_CHECK_SUCCESS';
export const AUTH_TYPE_CHECK_FAILURE = 'LOGIN/AUTH_TYPE_CHECK_FAILURE';
export const LOGIN_RESET = 'LOGIN/RESET';
export const GO_AUTH_AUTHENTICATE = 'LOGIN/GO_AUTH_AUTHENTICATE';
export const GO_AUTH_AUTHENTICATE_SUCCESS =
  'LOGIN/GO_AUTH_AUTHENTICATE_SUCCESS';
export const GO_AUTH_AUTHENTICATE_FAILURE =
  'LOGIN/GO_AUTH_AUTHENTICATE_FAILURE';
export const MOKA_AUTHENTICATE = 'LOGIN/MOKA_AUTHENTICATE';
export const MOKA_AUTHENTICATE_SUCCESS = 'LOGIN/MOKA_AUTHENTICATE_SUCCESS';
export const MOKA_AUTHENTICATE_FAILURE = 'LOGIN/MOKA_AUTHENTICATE_FAILURE';
